import { Component, Input } from '@angular/core';
import { OrderEntry } from '@spartacus/cart/base/root';
import { TranslatePipe } from '@spartacus/core';

@Component({
    selector: 'app-cart-sub-entry',
    templateUrl: './cart-sub-entry.component.html',
    imports: [TranslatePipe]
})
export class CartSubEntryComponent {
  @Input() subEntries: OrderEntry[];
}
